(function ($) {
  $(document).ready(function () {
    // header currency mobile
    $('.header-currency .localization-form label.disclosure__button').click(function() {
      $(this).parent().toggleClass('active');
    })
    $(document).click(function(event) { 
      var $target = $(event.target);
      if(!$target.closest('.header__icons .disclosure').length && $('.header__icons .disclosure').is(":visible")) {
        $('.header__icons .disclosure').removeClass('active');
      }        
    });

    // New piercing page click scroll
    $('.main-piercing .list-info .list-item a').click(function(e) {
      e.preventDefault();
      var href = $(this).attr('href');
      $('html, body').animate({
          scrollTop: $(href).offset().top - 150
      }, 500);
    });

    // Customer care page scroll
    var idSection = window.location.hash;
    if(idSection) {
      idSection = idSection.split(/[\s#]+/);
      idSection = idSection[idSection.length - 1];
      if($('#' + idSection).length > 0) {
        setTimeout(function(){ 
          $('html, body').animate({
            scrollTop: $('#' + idSection).offset().top - 150
          }, 500);
        }, 100);
      }
    }
        
    // Header menu hash click
    $('.header .mega-menu .mega-menu__link').click(function(e) {
      var hrefId = $(this).attr('href');
      hrefId = hrefId.split(/[\s#]+/);
      hrefId = hrefId[hrefId.length - 1];
      if($('#' + hrefId).length>0) {
        e.preventDefault();
        $('html, body').animate({
            scrollTop: $('#' + hrefId).offset().top - 200
        }, 500);
      }
    });

    // Blog post comment
    $('.article-toolbar .comment_form').click(function(e) {
      e.preventDefault();
      $('form#comment_form').slideToggle();
    });

    // Blog post feature image
    if($('.article-featured-slider').length>0) {
      $('.article-featured-slider').owlCarousel({
        loop:false,
        nav:false,
        dots:false,
        margin:0,
        items:2,
        responsiveClass:true,
        responsive:{
            0:{
                items:1
            },
            767:{
                items:1
            },
            768:{
                items:2
            }
        }
      })
    }

  });
  
  // Window loading
  setTimeout(function() {
    if($('.covetear-loadding').length > 0) {
      $('.covetear-loadding').addClass('hide');
    }
    $('body').addClass('loaded');
  }, 2000);
})(jQuery);